import { I4BGridFilterOptions } from '@iot-platform/models/grid-engine';
import { FilterFieldType } from './filter-field-type.enum';
import { Filter } from '@iot-platform/models/common';

export interface FilterConfigurationV2 {
  categories: (FilterFieldV2 | FilterCategoryV2)[];
}

export interface FilterCategoryV2 {
  key: string;
  label: string;
  order: number;
  fullLabel?: string;
  fields: FilterFieldV2[];
}

export interface FilterFieldV2 {
  key: string;
  label: string;
  categoryName?: string;
  fullLabel: string;
  fieldType: FilterFieldType;
  order: number;
  defaultFavorite?: boolean;
  operators: I4BGridFilterOptions[];
  defaultOperator?: I4BGridFilterOptions;
  options: Partial<FilterFieldOptions>;
}

export interface FilterFieldOptions {
  criteriaKey: string;
  criteriaLabel: string;
  criteriaValueAsString?: boolean;
  placeholder?: string;
  multiSelect?: boolean;
  autocomplete?: boolean;

  closeOnApply?: boolean;
  // For dropdown/autocomplete fields
  url?: string;
  list?: unknown[];
  filterBy?: string;
  labelToDisplay?: string;
  valueToDisplay?: string;
  selectByProperty?: string;
  // For tree view fields
  treeIdProperty?: string | null; // Property name for node ID (default: 'id')
  treeParentProperty?: string | null; // Property name for parent reference (e.g., 'parentId', 'parent')
  treeLevelProperty?: string | null; // Property name for level (default: 'level')
  treeIncludeAncestors?: boolean; // Build tree with all parent nodes (default: false)
  treeSelectOnlyLeafNodes?: boolean; // Allow selection of leaf nodes only (default: false)
  treeSelectDistinctNodes?: boolean; // Allow independent selection of each node without cascading (default: false)
  treeSuppressFirstNodeExpand?: boolean;
  // Date picker fields
  startDateLabel?: string;
  endDateLabel?: string;
  dateFormatterPattern?: string;
  // Timezone field
  displayOffset?: boolean;
  // For API calls
  arrayOrObject?: 'array' | 'object';
  sortMethod?: {
    type: string | null;
    property?: string | null;
  };
  skipAutoCompleteFilterCriteria?: boolean;
  distinctValues?: boolean;
  tooltip?: boolean;
  // For entity-specific
  includeSubEntities?: boolean;
  mapBusinessProfileEntityId?: boolean;
  // For date fields
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  // For number fields
  min?: number;
  max?: number;
  step?: number;

  displayWrapper?: (item: any) => string;
  displayValueWrapper?: (item: any) => string;
  dataTransform?: (data: any) => any;
}

const includeSubEntitiesFilter: Filter = {
  criteriaKey: 'includeSubEntities',
  criteriaOperator: I4BGridFilterOptions.EQUALS,
  value: true,
  isHidden: true,
  label: '',
  criteriaLabel: '',
  valueDisplay: true
};

export const additionalFiltersByCriteriaKey: { [criteriaKey: string]: { [additionalFilterName: string]: Filter } } = {
  entityId: {
    includeSubEntities: includeSubEntitiesFilter
  }
};
